import GeneralService from "./GeneralService";
import { Component } from "react";

export class ChatGPTService extends Component {

    public static getMessage(body: string, loadingHandler: any, user: any) {
        return GeneralService.post('/message/v3/new', body, loadingHandler, JSON, user);
    }

}